import { Checkbox, TableRow, Typography } from "@mui/material";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import { getObjectSelectLabel } from "../../../../../entityFields/helpers";
import ObjectAutocomplete from "./ObjectAutocomplete";
import TransactionEditContext from "./TransactionEditContext";
import type { TransactionRelatedEntity } from "./transactionEditState";
import TransactionTableCell from "./TransactionTableCell";

interface Props {
  relatedEntity: TransactionRelatedEntity;
}

const TransactionRelatedEntityRow = ({ relatedEntity }: Props) => {
  const { allEntities, editState, setEditState } = useDefinedContext(TransactionEditContext);

  const handleRowChange = (update: Partial<TransactionRelatedEntity>) => {
    setEditState((state) => {
      const relatedEntities = state.relatedEntities.map((entity) =>
        entity.changeSetId === relatedEntity.changeSetId ? { ...entity, ...update } : entity
      );
      return { ...state, relatedEntities };
    });
  };

  const invalidFields = editState.validationResults?.relatedEntitiesInvalidFields[relatedEntity.changeSetId] ?? [];

  return (
    <TableRow>
      <TransactionTableCell>
        <Checkbox
          checked={relatedEntity.isIncluded}
          onChange={(_, checked) => handleRowChange({ isIncluded: checked })}
          sx={{ pl: 2 }}
        />
      </TransactionTableCell>
      <TransactionTableCell sx={{ px: 2 }} hasError={!relatedEntity.entity || invalidFields.includes("entity")}>
        <Typography sx={{ pl: 2 }}>
          {relatedEntity.entity ? getObjectSelectLabel(relatedEntity.entity) : "No value"}
        </Typography>
      </TransactionTableCell>
      <TransactionTableCell hasError={invalidFields.includes("fundingEntity")}>
        <ObjectAutocomplete
          options={allEntities}
          value={relatedEntity.fundingEntity}
          onChange={(fundingEntity) => handleRowChange({ fundingEntity })}
          sx={{
            "& .MuiOutlinedInput-notchedOutline": { border: "none" },
          }}
        />
      </TransactionTableCell>
    </TableRow>
  );
};

export default TransactionRelatedEntityRow;
